/* @flow */
import { Record } from 'immutable'

import { currencies } from '../../configs/constants'

const InitialState = Record({
  isLoading: false,
  isLoginModalShown: false,
  isVideoModalShown: false,
  slides: [],
  user: null,
  registerInfo: null,
  item360: {},
  categories: [],
  alert: { isShown: false },
  currency: currencies[0],
  isMessageModalShown: false,
  messageModalParams: {},
  messages: [],
  announcements: [],
})
export default InitialState


// WEBPACK FOOTER //
// ./src/reducers/global/initialState.js